import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from "./i18n";
import 'bootstrap';
import 'bootstrap/scss/bootstrap.scss';
import Gravatar from 'vue-gravatar';
import VueCurrencyFilter from 'vue-currency-filter';
import { library } from "@fortawesome/fontawesome-svg-core";
import './assets/main.scss';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import vueCountryRegionSelect from 'vue-country-region-select';
require('../public/env');
import {
  faUser,
  faShoppingBasket,
  faTachometerAlt,
  faSignOutAlt,
  faFilm,
  faPlusCircle,
  faEllipsisV,
  faKey,
  faHandHoldingUsd,
  faPlug,
  faSync,
  faCreditCard,
  faFileInvoice,
  faEye,
  faAngleLeft,
  faAngleDoubleLeft,
  faAngleRight,
  faAngleDoubleRight,
  faPlay,
  faFileCsv,
  faCertificate,
  faFile,
  faDownload,
  faTrash,
  faUserEdit,
  faUndo,
  faSave,
  faHistory,
  faInfoCircle,
  faSlidersH,
  faFileExport,
  faTruck,
  faCheck,
  faClipboard
} from "@fortawesome/free-solid-svg-icons";
library.add(
    faUser,
    faShoppingBasket,
    faTachometerAlt,
    faSignOutAlt,
    faFilm,
    faPlusCircle,
    faEllipsisV,
    faKey,
    faHandHoldingUsd,
    faPlug,
    faSync,
    faCreditCard,
    faFileInvoice,
    faEye,
    faAngleLeft,
    faAngleDoubleLeft,
    faAngleRight,
    faAngleDoubleRight,
    faPlay,
    faFileCsv,
    faCertificate,
    faFile,
    faDownload,
    faTrash,
    faUserEdit,
    faUndo,
    faSave,
    faHistory,
    faInfoCircle,
    faSlidersH,
    faFileExport,
    faTruck,
    faCheck,
    faClipboard
);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('v-gravatar', Gravatar);

Vue.use(VueCurrencyFilter, {
  symbol: '€',
  thousandsSeparator: '.',
  fractionCount: 2,
  fractionSeparator: ',',
  symbolPosition: 'front',
  symbolSpacing: true
});
Vue.use(vueCountryRegionSelect);

Vue.config.productionTip = false;

Vue.filter('formatBytes', function(bytes, decimals = 2) {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
